module.exports = __webpack_public_path__ + "static/img/course_description.e92efc58.jpg";